import { apiRequest } from "./apiClient";

export function loginAdmin(credentials) {
  return apiRequest("/auth/login", {
    method: "POST",
    body: credentials,
  });
}

export function fetchCurrentAdmin() {
  return apiRequest("/auth/me");
}

export function saveCurrentAdminProfile(item) {
  return apiRequest("/auth/me", {
    method: "POST",
    body: item,
  });
}

export function fetchAdminOverview() {
  return apiRequest("/admin/overview");
}

export function fetchAdminUsers() {
  return apiRequest("/admin/users");
}

export function fetchAdminLeads() {
  return apiRequest("/admin/leads");
}

export function saveAdminLead(item) {
  return apiRequest("/admin/leads", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminLead(id) {
  return apiRequest("/admin/leads/delete", {
    method: "POST",
    body: { id },
  });
}

export function saveAdminUser(item) {
  return apiRequest("/admin/users", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminUser(id) {
  return apiRequest("/admin/users/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchAdminJobs() {
  return apiRequest("/admin/jobs");
}

export function saveAdminJob(item) {
  return apiRequest("/admin/jobs", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminJob(id) {
  return apiRequest("/admin/jobs/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchAdminClients() {
  return apiRequest("/admin/clients");
}

export function saveAdminClient(item) {
  return apiRequest("/admin/clients", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminClient(id) {
  return apiRequest("/admin/clients/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchAdminOffers() {
  return apiRequest("/admin/offers");
}

export function saveAdminOffer(item) {
  return apiRequest("/admin/offers", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminOffer(id) {
  return apiRequest("/admin/offers/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchAdminInvoices() {
  return apiRequest("/admin/invoices");
}

export function saveAdminInvoice(item) {
  return apiRequest("/admin/invoices", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminInvoice(id) {
  return apiRequest("/admin/invoices/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchCalendarEvents() {
  return apiRequest("/admin/calendar/events");
}

export function fetchAdminPriceItems() {
  return apiRequest("/admin/pricing");
}

export function saveAdminPriceItem(item) {
  return apiRequest("/admin/pricing", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminPriceItem(id) {
  return apiRequest("/admin/pricing/delete", {
    method: "POST",
    body: { id },
  });
}

export function startGoogleCalendarConnect() {
  return apiRequest("/admin/google-calendar/connect", {
    method: "POST",
  });
}

export function fetchAdminSiteContent() {
  return apiRequest("/admin/site-content");
}

export function saveAdminSiteContent(content) {
  return apiRequest("/admin/site-content", {
    method: "POST",
    body: { content },
  });
}

export function saveAdminSiteService(item) {
  return apiRequest("/admin/site-services", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminSiteService(id) {
  return apiRequest("/admin/site-services/delete", {
    method: "POST",
    body: { id },
  });
}

export function fetchAdminRealizations() {
  return apiRequest("/admin/realizations");
}

export function saveAdminRealization(item) {
  return apiRequest("/admin/realizations", {
    method: "POST",
    body: item,
  });
}

export function deleteAdminRealization(id) {
  return apiRequest("/admin/realizations/delete", {
    method: "POST",
    body: { id },
  });
}
